import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cd1a7012")

_pushScopeId("data-v-cd1a7012")
const _hoisted_1 = { class: "answer-container" }
const _hoisted_2 = { class: "cover-wrapper" }
const _hoisted_3 = { class: "detail-title" }
const _hoisted_4 = { class: "detail-image" }
const _hoisted_5 = {
  key: 0,
  class: "form-item"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "卡号", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "待发放", -1)
const _hoisted_8 = {
  key: 1,
  class: "form-item"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "兑换码", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "待发放", -1)
const _hoisted_11 = {
  key: 2,
  class: "form-item"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "手机号码", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Back = _resolveComponent("Back")
  const _component_Action = _resolveComponent("Action")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, {
    circleRight: true,
    circleTop: true,
    flower: true,
    spot: true,
    starTop: true,
    starMiddle: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { text: `奖品兑换` }),
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(_ctx.data.name), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: _ctx.data.img
            }, null, 8, ["src"])
          ]),
          (!_ctx.data.isActive)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (!_ctx.data.isActive)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10
              ]))
            : _createCommentVNode("", true),
          (_ctx.data.isActive)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("input", {
                  placeholder: "请填写联系人手机号码",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mobile = $event))
                }, null, 512), [
                  [_vModelText, _ctx.mobile]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.data.isActive)
          ? (_openBlock(), _createBlock(_component_Action, {
              key: 0,
              text: `兑换`,
              onAction: _ctx.submit
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
})